// extracted by mini-css-extract-plugin
module.exports = {"PRICE_FILTER":"PriceFilter_PRICE_FILTER__3E17A","PRICE_FILTER__slider":"PriceFilter_PRICE_FILTER__slider__3b_hG"};